import EmojiIcon from '@atlaskit/icon/core/emoji';
import * as React from 'react';

export function SvgSmile() {
  return <EmojiIcon label="" testId="ads-refreshed-icon" />;
}
